import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import BlockSkeleton from "../../interfaccia/loading/BlockSkeleton";
import { creaApiKitModa, isAnnullata, messaggioErrore } from "../../modificaProdotti/pagine/kitModa/kitModaApi";
import KitModaImportJob from "./KitModaImportJob";

export const MODALITA = {
  DUE_COMPONENTI: "Kit sci/completi (col 1: EAN kit / col 2: EAN primo componente / col 3: EAN secondo componente)",
  COMPONENTE_SINGOLO: "Palline/altri bundle componente singolo (col 1: EAN kit / col 2: EAN componente)",
  AVANZATA: "Avanzata (una riga per componente, col 1: EAN kit / col 2: EAN componente / col 3: quantità componente)",
};
const STATI = {
  SENZA_KIT: "Senza kit", UGUALE: "Già uguale – saltato", DIVERSO: "Kit diverso",
  NON_VERIFICATO: "Non verificato: verrà riletto prima dell'invio",
};
const COMPOSIZIONI = {
  NUOVA: "Nuova", UGUALE: "Già uguale", SOSTITUITA: "Sostituisce l'attuale", NON_UNIFORME: "Non uniforme: non salvata",
};
const CONTATORI = {
  kit: "Kit", importabili: "Importabili", conErrori: "Con errori", senzaKit: "Senza kit",
  uguali: "Già uguali", diversi: "Diversi", nonVerificati: "Non verificati",
};
const { buttonClassesWhite, buttonClassesGreen, inputClassesNoMeasure } = stilePulsanti;
const senzaErrori = riga => !riga.errori?.length;

function Messaggi({ valori = [] }) {
  return valori.length ? <ul className="pl3 ma0">{valori.map((m, i) => <li key={i}>{m}</li>)}</ul> : null;
}

function Anteprima({ preview, onSelezione, filtro, setFiltro, tutte, setTutte, bloccato }) {
  const { dati, snapshot } = preview;
  const diversi = dati.kit.filter(r => r.statoAttuale === "DIVERSO" && senzaErrori(r));
  const tuttiSelezionati = diversi.length > 0 && diversi.every(r => snapshot.sovrascrivi.includes(r.tripletta));
  const filtrate = dati.kit.filter(r => !filtro || (filtro === "ERRORI" ? !senzaErrori(r) : r.statoAttuale === filtro));
  const visibili = tutte ? filtrate : filtrate.slice(0, 100);
  return <section aria-label="Anteprima Kit Moda">
    <h3>Anteprima</h3>
    <p>Righe lette: {dati.righeLette} · Intestazione saltata: {dati.intestazioneSaltata ? "Sì" : "No"}</p>
    <div className="flex flex-wrap">{Object.entries(CONTATORI).map(([k, label]) =>
      <p className="mr3" key={k}>{label}: {dati.riepilogo?.[k] ?? 0}</p>)}</div>
    {!!dati.erroriFile?.length && <div role="alert"><h4>Errori del file</h4><Messaggi valori={dati.erroriFile} /></div>}
    <label>Filtra kit per stato <select value={filtro} onChange={e => { setFiltro(e.target.value); setTutte(false); }}>
      <option value="">Tutti</option>{Object.entries(STATI).map(([k, label]) => <option key={k} value={k}>{label}</option>)}
      <option value="ERRORI">Con errori</option>
    </select></label>
    <button type="button" className={buttonClassesWhite} disabled={bloccato || !diversi.length}
      onClick={() => onSelezione(tuttiSelezionati ? [] : diversi.map(r => r.tripletta))}>
      {tuttiSelezionati ? "Deseleziona tutti i diversi" : "Seleziona tutti i diversi"}
    </button>
    <p>Visibili {visibili.length} di {filtrate.length} kit. Il filtro modifica solo la visualizzazione.</p>
    <div className="overflow-x-auto"><table className="collapse w-100" aria-label="Kit da CSV">
      <thead><tr className="tl bb bordoColAlt">{["Sovrascrivi", "EAN / codVS", "Taglia", "Componenti", "Stato attuale", "Errori / avvisi"].map(t => <th className="pa2" key={t}>{t}</th>)}</tr></thead>
      <tbody>{visibili.map((r, i) => <tr key={r.tripletta || i} className="bt bordoColAlt v-top">
        <td className="pa2">{r.statoAttuale === "DIVERSO" && senzaErrori(r) && <input type="checkbox"
          aria-label={`Sovrascrivi ${r.tripletta}`} disabled={bloccato} checked={snapshot.sovrascrivi.includes(r.tripletta)}
          onChange={e => onSelezione(e.target.checked ? [...snapshot.sovrascrivi, r.tripletta] : snapshot.sovrascrivi.filter(t => t !== r.tripletta))} />}</td>
        <td className="pa2">{r.ean}<span className="db">{r.codVS}</span><small>Righe: {r.righe?.join(", ")}</small></td>
        <td className="pa2">{r.taglia}<small className="db">{r.tripletta}</small></td>
        <td className="pa2"><ul className="pl3 ma0">{r.componenti.map((c, j) => <li key={j}>{c.ean} / {c.codVS} / {c.taglia} × {c.quantita}</li>)}</ul></td>
        <td className="pa2">{STATI[r.statoAttuale] || r.statoAttuale}
          {!!r.attuali?.length && <details><summary>Componenti attuali</summary><ul>{r.attuali.map((c, j) => <li key={j}>{c.tripletta} × {c.quantita}</li>)}</ul></details>}</td>
        <td className="pa2"><Messaggi valori={r.errori} /><Messaggi valori={r.avvisi} /></td>
      </tr>)}</tbody>
    </table></div>
    {filtrate.length > 100 && <button type="button" className={buttonClassesWhite} onClick={() => setTutte(!tutte)}>{tutte ? "Mostra prime 100" : "Mostra tutte"}</button>}
    <details className="mv3"><summary>Composizioni articolo ({dati.composizioni.length})</summary>
      {dati.composizioni.map((c, i) => <div key={i} className="pa2 bb bordoColAlt"><strong>{c.codVS}: {COMPOSIZIONI[c.stato] || c.stato}</strong>
        <p>{c.componenti.map(p => `${p.codVS} × ${p.quantita}`).join(", ")}</p>
        {!!c.attuale?.length && <p>Attuale: {c.attuale.map(p => `${p.codVS} × ${p.quantita}`).join(", ")}</p>}
      </div>)}
    </details>
  </section>;
}

export default function KitModaImport({ utente }) {
  const { getAccessTokenSilently } = useAuth0();
  const username = typeof utente?.username === "string" ? utente.username.trim() : "";
  const puoLeggere = Boolean(utente?.permessiAPI?.["update:database"]);
  const puoInviare = puoLeggere && Boolean(utente?.permessiAPI?.["update:prestashop"]);
  const api = useMemo(() => creaApiKitModa({ getAccessTokenSilently, username }), [getAccessTokenSilently, username]);
  const [form, setForm] = useState({ file: null, modalita: "DUE_COMPONENTI", quantita: "" });
  const [preview, setPreview] = useState(null);
  const [errore, setErrore] = useState("");
  const [loading, setLoading] = useState(false);
  const [invio, setInvio] = useState(false);
  const [jobId, setJobId] = useState("");
  const [jobAttivo, setJobAttivo] = useState(false);
  const [filtro, setFiltro] = useState("");
  const [tutte, setTutte] = useState(false);
  const richieste = useRef({ mounted: false, versione: 0, controller: null, invio: false });
  const storageKey = `domino:kit-moda-import:${username}`;
  useEffect(() => {
    const ref = richieste.current;
    ref.mounted = true;
    return () => { ref.mounted = false; ref.versione++; ref.controller?.abort(); };
  }, []);
  useEffect(() => {
    if (!username || !puoLeggere) return;
    try {
      const id = localStorage.getItem(storageKey);
      if (id) { setJobId(id); setJobAttivo(true); }
    } catch (_) { /* La persistenza è facoltativa. */ }
  }, [storageKey, username, puoLeggere]);

  const jobNonTrovato = useCallback(() => {
    try { localStorage.removeItem(storageKey); } catch (_) { /* Facoltativo. */ }
    setJobId(""); setJobAttivo(false);
    setErrore("L'ultimo job di import non è più disponibile: puoi avviare un nuovo import.");
  }, [storageKey]);

  const bloccato = invio || jobAttivo;
  const quantitaValida = form.modalita !== "COMPONENTE_SINGOLO" || (/^\d+$/.test(form.quantita) && Number(form.quantita) >= 1 && Number(form.quantita) <= 999);
  const motivoBlocco = !username ? "Username Domino mancante: ricarica il profilo utente prima dell'import."
    : !puoLeggere ? "Serve il permesso update:database per l'anteprima." : "";
  const corrente = preview && preview.form === form && preview.snapshot.updatedBy === username;
  const kitDaInviare = corrente ? preview.dati.kit.filter(r => senzaErrori(r) &&
    ["SENZA_KIT", "NON_VERIFICATO", "DIVERSO"].includes(r.statoAttuale) &&
    (r.statoAttuale !== "DIVERSO" || preview.snapshot.sovrascrivi.includes(r.tripletta))).length : 0;
  const composizioniDaSalvare = corrente ? preview.dati.composizioni.filter(c => ["NUOVA", "SOSTITUITA"].includes(c.stato)).length : 0;

  function aggiornaForm(patch) {
    if (richieste.current.invio || jobAttivo) return;
    richieste.current.versione++;
    richieste.current.controller?.abort();
    setForm(old => ({ ...old, ...patch }));
    setPreview(null); setLoading(false); setErrore("");
  }
  async function anteprima() {
    if (motivoBlocco || !form.file || !quantitaValida || bloccato || richieste.current.invio) return;
    const ref = richieste.current;
    ref.controller?.abort();
    const controller = new AbortController();
    ref.controller = controller;
    const versione = ++ref.versione;
    const attuale = () => ref.mounted && ref.versione === versione && !controller.signal.aborted;
    const snapshot = { ...form, updatedBy: username, sovrascrivi: [] };
    setPreview(null); setErrore(""); setLoading(true); setFiltro(""); setTutte(false);
    try {
      const dati = await api.anteprimaImport(snapshot, controller.signal);
      if (attuale()) setPreview({ form, snapshot, dati });
    } catch (err) {
      if (attuale() && !isAnnullata(err)) setErrore(messaggioErrore(err, "Anteprima non riuscita"));
    } finally { if (attuale()) setLoading(false); }
  }
  async function avvia() {
    if (!corrente || !puoInviare || motivoBlocco || !kitDaInviare || preview.dati.erroriFile?.length || bloccato || richieste.current.invio) return;
    const ref = richieste.current;
    ref.invio = true; setInvio(true); setErrore("");
    try {
      const dati = await api.avviaImport(preview.snapshot);
      if (!dati.jobId) throw new Error("Il backend non ha restituito il jobId. Verifica l'import prima di riprovare.");
      // Ricordiamo il job anche se nel frattempo la pagina è stata chiusa; non annulliamo la scrittura.
      try { localStorage.setItem(storageKey, dati.jobId); } catch (_) { /* Facoltativo. */ }
      if (ref.mounted) { setJobId(dati.jobId); setJobAttivo(true); setPreview(null); }
    } catch (err) {
      if (ref.mounted) setErrore(`${messaggioErrore(err, "Avvio import non riuscito")}. Se la risposta è andata persa, il job potrebbe essere partito: verifica prima di riprovare.`);
    } finally { ref.invio = false; if (ref.mounted) setInvio(false); }
  }

  return <div className="pa3">
    <h2>Kit Moda</h2>
    <p>Importa i kit delle taglie su Prestashop VIG via Tembo e le composizioni articolo in Domino.</p>
    <p>La prima riga è trattata come intestazione se non contiene EAN; i nomi delle colonne non contano.</p>
    {motivoBlocco && <p role="alert">{motivoBlocco}</p>}
    {!puoInviare && puoLeggere && <p>Per avviare l'import serve anche il permesso update:prestashop.</p>}
    <fieldset disabled={bloccato} className="bn pa0 ma0"><legend className="b">File e modalità</legend>
      {Object.entries(MODALITA).map(([value, label]) => <label className="db mv2" key={value}>
        <input type="radio" name="kit-moda-modalita" value={value} checked={form.modalita === value}
          onChange={() => aggiornaForm({ modalita: value })} /> {label}
      </label>)}
      {form.modalita === "COMPONENTE_SINGOLO" && <label className="db mv3">Quantità componente (obbligatoria, da 1 a 999)
        <input className={inputClassesNoMeasure} type="number" min="1" max="999" step="1" required value={form.quantita}
          onChange={e => aggiornaForm({ quantita: e.target.value })} />
      </label>}
      <label className="db mv3">File CSV <input type="file" accept=".csv" onChange={e => aggiornaForm({ file: e.target.files?.[0] || null })} /></label>
      <button type="button" className={buttonClassesWhite} onClick={anteprima}
        disabled={!!motivoBlocco || !form.file || !quantitaValida || loading}>Anteprima</button>
    </fieldset>
    {errore && <p role="alert">{errore}</p>}
    {(loading || invio) && <BlockSkeleton height={180} aria-label={invio ? "Avvio del job" : "Lettura anteprima"} />}
    {corrente && <>
      <Anteprima preview={preview} bloccato={bloccato} filtro={filtro} setFiltro={setFiltro} tutte={tutte} setTutte={setTutte}
        onSelezione={sovrascrivi => setPreview(old => ({ ...old, snapshot: { ...old.snapshot, sovrascrivi } }))} />
      <section aria-label="Conferma import"><h3>Conferma</h3>
        <p>Da inviare: {kitDaInviare} kit su Prestashop VIG; {composizioniDaSalvare} composizioni articolo proposte da salvare.</p>
        <p>I conteggi saranno ricalcolati dal backend. I kit diversi sono inviati solo se selezionati; quelli già uguali e quelli con errori sono saltati.</p>
        <p className="b">Attenzione: scrive sul Prestashop reale, anche da Domino beta. Il job continua anche chiudendo questa pagina.</p>
        <button type="button" className={buttonClassesGreen} onClick={avvia}
          disabled={bloccato || !!motivoBlocco || !puoInviare || !kitDaInviare || !!preview.dati.erroriFile?.length}>Avvia import</button>
      </section>
    </>}
    {jobId && puoLeggere && <KitModaImportJob key={`${storageKey}:${jobId}`} jobId={jobId} api={api} onAttivo={setJobAttivo} onNonTrovato={jobNonTrovato} />}
  </div>;
}
